// extracted by mini-css-extract-plugin
export var progressBar = "_ls-0";
export var progressBarInner = "_ls-1";